/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/** 
  All of the routes for the page layout of Soft UI Dashboard PRO React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the DefaultNavbar.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `name` key is used for the name of the route on the DefaultNavbar.
  3. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  4. The `icon` key is used for the icon of the route on the DefaultNavbar, you have to add a node.
  5. The `collapse` key is used for making a collapsible item on the DefaultNavbar that contains other routes inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  6. The `route` key is used to store the route location which is used for the react router.
  7. The `href` key is used to store the external links location.
*/

// Soft UI Dashboard PRO React icons
import Shop from "template/examples//Icons/Shop";
import Office from "template/examples//Icons/Office";
import Document from "template/examples//Icons/Document";
import CustomerSupport from "template/examples//Icons/CustomerSupport";
import Cube from "template/examples//Icons/Cube";
import SpaceShip from "template/examples//Icons/SpaceShip";


import DevicesTableView from "pages/views/DevicesTableView";
import DeviceView from "pages/views/DeviceView";
import LandingView from "pages/views/LandingView";
import MapView from "pages/views/MapView";
import ContentRepositoryView from "pages/views/ContentRepositoryView";

import NewInspectionView from "pages/views/NewInspectionView";
import AllInspectionsView from "pages/views/AllInspectionsView";

import ClearwayDeviceGroupsView from "modules/clearways/views/ClearwayGroupsView/Group";
import ClearwayDeviceGroupView from "modules/clearways/views/ClearwayGroupView";
import ClearwayDeviceSubgroupsView from "modules/clearways/views/ClearwayGroupsView/Subgroup";

import ClearwaysEventsView from "modules/clearways/views/ClearwaysEventsView";
import ClearwaysEventView from "modules/clearways/views/ClearwaysEventView";
import ClearwaysEventEdit from "modules/clearways/views/ClearwaysEventEdit";
import ClearwaysEventAdd from "modules/clearways/views/ClearwaysEventAdd";

import ClearwaysSubgroupsMapView from "pages/components/Map/ClearwaysMaps/Subgroups";


import AllCampaignsView from "pages/views/AllCampaignsView";
import DeviceCampaignsView from "pages/components/Devices/DeviceView/Campaigns";
import AllAssignmentsView from "pages/views/AllAssignmentsView";
import NewAssignmentView from "pages/views/NewAssignmentView";
import ClearwaysDevicesMapView from "pages/components/Map/ClearwaysMaps/Devices";
import CampaignView from "pages/views/CampaignView";
import TranslationsView from "pages/views/TranslationsView";
import SettingsView from "pages/views/SettingsView";

const pageRoutes = [
  {
    name: "Home",
    key: "home",
    icon: <Shop size="12px" color="white" />,
    route: "/",
    component: LandingView,
    in_menu: false,
  },
  {
    name: "Overview",
    key: "overview",
    icon: <Shop size="12px" color="white" />,
    component: MapView,
    collapse: [
      {
        name: "Stopmonitor Map",
        key: "stopmonitor-overview",
        route: "/overview",
        component: MapView,
        in_menu: true
      },
      {
        name: "Clearways Map",
        key: "clearways-overview",
        route: "/overview",
        component: MapView,
        in_menu: true
      }
    ],
    in_menu: true,
  },
  {
    name: "Subgroup Overview",
    key: "subgroup-view",
    icon: <Shop size="12px" color="white" />,
    route: "/overview/:group_id",
    component: ClearwaysSubgroupsMapView,
    in_menu: false,
  },
  {
    name: "Device Overview",
    key: "device-view",
    icon: <Shop size="12px" color="white" />,
    route: "/overview/:group_id/:subgroup_id",
    component: ClearwaysDevicesMapView,
    in_menu: false,
  },
  {
    name: "Devices",
    key: "devices",
    icon: <Shop size="12px" color="white" />,
    route: "/devices",
    component: DevicesTableView,
    in_menu: true
  },
  {
    name: "Device View",
    key: "devices-single",
    route: "/devices/:uuid",
    component: DeviceView,
    in_menu: false
  },
  {
    name: "Media",
    key: "media",
    icon: <Shop size="12px" color="white" />,
    route: "/media",
    component: ContentRepositoryView,
    in_menu: true
  },
  {
    name: "Settings",
    key: "settings",
    icon: <Shop size="12px" color="white" />,
    route: "/settings",
    component: SettingsView,
    in_menu: false
  },
  {
    name: "Inspections",
    key: "operations-inspections",
    icon: <Shop size="12px" color="white" />,
    collapse: [
      {
        name: "New Inspection",
        key: "new-inspection-report",
        route: "/operations/new-inspection",
        icon: "add_circle_outline",
        component: NewInspectionView,
        in_menu: true
      },
      {
        name: "View All Inspections",
        key: "inspection-view",
        route: "/operations/inspections",
        component: AllInspectionsView,
        in_menu: true
      },
    ],
    in_menu: true
  },
  {
    name: "Assignments",
    key: "operations-assignments",
    icon: <Shop size="12px" color="white" />,
    collapse: [
      {
        name: "New Assignment",
        key: "new-assignment-task",
        route: "/operations/assignments/:assignment_id",
        component: NewAssignmentView,
        in_menu: false
      },
      {
        name: "Active Assignments",
        key: "assignment-view",
        route: "/operations/assignments",
        component: AllAssignmentsView,
        in_menu: true
      },
    ],
    in_menu: true
  },
  {
    name: "Campaign Manager",
    key: "campaign_manager",
    icon: <Shop size="12px" color="white" />,
    route: "/campaign",
    component: AllCampaignsView,
    in_menu: true
  },
  {
    name: "Edit Campaign",
    key: "campaign_editor",
    icon: <Shop size="12px" color="white" />,
    route: "/campaign/:id",
    component: CampaignView,
    in_menu: false
  },
  {
    name: "Translations",
    key: "translations",
    icon: <Shop size="12px" color="white" />,
    route: "/translations",
    component: TranslationsView,
    in_menu: true
  },
  // {
  //   name: "Device Campaigns",
  //   key: "campaign_manager-device",
  //   icon: <Shop size="12px" color="white" />,
  //   route: "/campaigns/:uuid",
  //   component: DeviceCampaignsView,
  //   in_menu: false
  // },
  {
    name: "Clearways Groups",
    key: "clearways-groups",
    icon: <Shop size="12px" color="white" />,
    // route: "/clearways",
    collapse: [
      {
        name: "View All Groups",
        key: "groups-view",
        route: "/clearways/groups",
        component: ClearwayDeviceGroupsView,
        in_menu: true,
      },
      {
        name: "View All Group's Subgroups",
        key: "subgroups-view",
        route: "/clearways/groups/:group_id/subgroups",
        component: ClearwayDeviceSubgroupsView,
        in_menu: false,
      },
      {
        name: "Selected Group",
        key: "group-view",
        route: "/clearways/groups/:group_id",
        component: ClearwayDeviceGroupView,
        in_menu: false,
      }
    ],
    in_menu: true
  },
  {
    name: "Clearways Events",
    key: "clearways-events",
    icon: <Shop size="12px" color="white" />,
    // route: "/clearways",
    collapse: [
      {
        name: "View All Events",
        key: "events-view",
        route: "/clearways/events",
        component: ClearwaysEventsView,
        in_menu: true,
      },
      {
        name: "Selected Event",
        key: "event-view",
        route: "/clearways/events/:event_id",
        component: ClearwaysEventView,
        in_menu: false,
      },
      {
        name: "Selected Event Edit",
        key: "event-edit",
        route: "/clearways/events/:event_id/edit",
        component: ClearwaysEventEdit,
        in_menu: false,
      },
      {
        name: "Add Event",
        key: "event-add",
        route: "/clearways/event",
        component: ClearwaysEventAdd,
        in_menu: false,
      },
    ],
    in_menu: true
  },
  {
    name: "Crowd Counting",
    key: "crowds",
    route: "/crowds",
    // component: CrowdCountingEventList,
    in_menu: true
  },
  {
    name: "Crowd Event",
    key: "crowds-event",
    route: "/crowds/:event_id",
    // component: CrowdCountingEventView,
    in_menu: false
  },
  {
    name: "Crowd Event Device",
    key: "crowds-event-device",
    route: "/crowds/:event_id/:uuid",
    // component: CrowdCountingEventView,
    in_menu: false
  },
];

export default pageRoutes;
